import React from 'react';
import moment from 'moment';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { useQuery } from 'react-query';
import FlexPanel from '../FlexPanel';
import ApiService from '../../services/ApiService';
import { handleDocuments, handleHistory } from './actions';
import SimpleQuoteLink from './SimpleQuoteLink';
import FileNotFound from '../FileNotFound';

const RecentlyClosed = () => {
  const { isLoading, data = [] } = useQuery('closed-quotes', async () => {
    const { data } = await ApiService.get('crm/quotes/closed');
    return data;
  });

  const renderTable = () => {
    return (
      <table>
        <tbody>
          {data.map(quote => {
            const key = String(quote.id);

            return (
              <tr key={key}>
                <td width="10">
                  <i
                    className="fas fa-circle"
                    style={{ color: quote.QuoteState.color }}
                    title={quote.QuoteState.name}
                  />
                </td>
                <td>
                  <SimpleQuoteLink quote={quote} />
                </td>
                <td>{quote.customerId}</td>
                <td>{quote.vehicleId}</td>
                <td>{moment(new Date(quote.updatedAt)).fromNow(true)}</td>
                <td>
                  <div className="text-right">
                    {`${(quote.data.quoteWithFETAddons || 0 / 1).toLocaleString('en-US', {
                      style: 'currency',
                      currency: 'USD',
                    })}`}
                  </div>
                </td>
                <td>
                  <div className="actions text-right">
                    <DropdownButton id="actions" title="Actions" variant="primary" alignRight>
                      <Dropdown.Item onClick={() => handleHistory(quote.id)}>History</Dropdown.Item>
                      <Dropdown.Item onClick={() => handleDocuments(quote.id)}>Documents</Dropdown.Item>
                      {/* <Dropdown.Divider />
                    <Dropdown.Item onClick={() => handleReopen(quote.id)}>Reopen</Dropdown.Item> */}
                    </DropdownButton>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  if (isLoading) {
    return <div />;
  }

  if (!data.length) {
    return (
      <FlexPanel header="Recently Closed">
        <FileNotFound>Any recently closed or cancelled quotes will populate here</FileNotFound>
      </FlexPanel>
    );
  }

  return (
    <FlexPanel header="Recently Closed">
      <div className="quote-list">{renderTable()}</div>
    </FlexPanel>
  );
};

RecentlyClosed.propTypes = {};

export default RecentlyClosed;
